import Stickyfill from 'stickyfilljs';

import {
  AnimateGroupReveal,
  AnimateReveal,
  AudioPlayer,
  BackgroundVideo,
  CaliberBlock,
  checkoutMobile,
  ClientReview,
  Collapse,
  datepickerField,
  drawer,
  ExpandableDetailsGrid,
  header,
  helpers,
  LargeScaleDownMedia,
  LayeredSections,
  MediaCardExpandable,
  Modal,
  modalScrollable,
  Orchid,
  Panel,
  Particles,
  phoneField,
  PhxToaster,
  Range,
  ScaleVideoRevealContent,
  ScrollPinnedSlider,
  slider,
  SliderFaded,
  StackedInteractiveMedia,
  StickyAddToCart,
  stickyBar,
  stickyBarContextual,
  stickyBarNavigation,
  StickyFiftyFiftyParallax,
  Tooltip,
  VideoPlayer,
  Ww25ModalController,
} from '@phx-styleguides/jlc';
import * as Accordion from '@phoenix/components/Accordion';

/* We redefine the method for now until DSPHX-1890 is done on SG side. */
const sgphxAddLoadingState = helpers.buttons.addLoadingState;
const addLoadingState = (node, data = {}) => {
  if (!node) return;
  if (!Object.hasOwn(data, 'dark') && ['btn--negative', 'btn--alternative'].some((c) => node.classList.contains(c))) {
    data.dark = false;
  }
  sgphxAddLoadingState(node, data);
};

helpers.buttons.addLoadingState = addLoadingState;

export {
  Accordion,
  AnimateGroupReveal,
  AnimateReveal,
  AudioPlayer,
  BackgroundVideo,
  checkoutMobile,
  CaliberBlock,
  ClientReview,
  Collapse,
  datepickerField,
  drawer,
  ExpandableDetailsGrid,
  header,
  helpers,
  LayeredSections,
  LargeScaleDownMedia,
  MediaCardExpandable,
  Modal,
  modalScrollable,
  Orchid,
  Panel,
  Particles,
  phoneField,
  PhxToaster,
  Range,
  ScaleVideoRevealContent,
  ScrollPinnedSlider,
  slider,
  SliderFaded,
  StackedInteractiveMedia,
  StickyAddToCart,
  stickyBar,
  stickyBarNavigation,
  stickyBarContextual,
  StickyFiftyFiftyParallax,
  Stickyfill,
  Tooltip,
  VideoPlayer,
  Ww25ModalController,
};
